export enum EnvelopeType {
  Low = 'Low',
  Hi = 'Hi',
  LowLow = 'LowLow',
  HiHi = 'HiHi',
}
